/**
 * Cierra la app cuando corre dentro del shell Electron (IPC → app.quit).
 * En navegador puro no hace nada.
 */
export function requestElectronQuit () {
  if (typeof window === 'undefined' || typeof window.electronAPI?.quitApp !== 'function') {
    return
  }
  void window.electronAPI.quitApp().catch((err) => {
    console.warn('[requestElectronQuit]', err)
  })
}
